import { v4 as uuidv4 } from "uuid";
import { newRelicErrorLog } from "../utils/newRelicLogs";

const maeAudioStreamingURL =
  process.env.REACT_APP_MAE_AUDIO_STREAMING_WS_SERVER_URL;

class AudioStreamingWS {
  constructor() {
    this.connectionInstances = {};
  }

  reconnectWebsocket(
    dealershipId,
    onWebsocketOpen,
    onWebsocketMessage,
    onWebsocketClosed,
    onWebsocketError
  ) {
    const oldSessionId = localStorage.getItem("recordingSessionId") || null;

    this.connectWebsocket(
      dealershipId,
      oldSessionId ? oldSessionId : uuidv4(),
      onWebsocketOpen,
      onWebsocketMessage,
      onWebsocketClosed,
      onWebsocketError
    );
  }

  connectWebsocket(
    dealershipId,
    sessionId,
    onWebsocketOpen,
    onWebsocketMessage,
    onWebsocketClosed,
    onWebsocketError
  ) {
    localStorage.setItem("recordingSessionId", sessionId);

    try {
      const currentInstance = this.connectionInstances[sessionId];
      if (
        currentInstance &&
        (currentInstance?.readyState === WebSocket.OPEN ||
          currentInstance?.readyState === WebSocket.CONNECTING)
      ) {
        console.warn("WebSocket already open for this session:", sessionId);
        newRelicErrorLog(
          {},
          {
            dealershipId,
            recordingSessionId: sessionId || "blank:recordingSessionId",
            originated: "AudioStreamingWS Class",
          },
          "WebSocket already open for this session"
        );
        return;
      }

      if (currentInstance) {
        console.log("Cleaning up stale instance before creating new one");
        this.clearInstance(sessionId);
      }

      const ws_url =
        maeAudioStreamingURL + sessionId + "/" + dealershipId + "/sales-web";

      // Connect websocket
      this.connectionInstances[sessionId] = new WebSocket(ws_url);

      // Handle connection open
      this.connectionInstances[sessionId].onopen = onWebsocketOpen;

      // Handle incoming messages
      this.connectionInstances[sessionId].onmessage = onWebsocketMessage;

      // Handle connection close
      this.connectionInstances[sessionId].onclose = onWebsocketClosed;

      // Handle connection error
      this.connectionInstances[sessionId].onerror = onWebsocketError;
    } catch (error) {
      console.error("Error in Connecting to the Websocket Instance:", error);
      newRelicErrorLog(error, {
        dealershipId,
        recordingSessionId: sessionId || "blank:recordingSessionId",
        originated: "AudioStreamingWS Class",
      });
    }
  }

  getInstance(sessionId) {
    return this.connectionInstances[sessionId] || null;
  }

  clearInstance(sessionId) {
    const currentInstance = this.getInstance(sessionId);
    if (currentInstance) {
      delete this.connectionInstances[sessionId];
    }
  }

  destroyInstance(sessionId, reason) {
    const instance = this.connectionInstances[sessionId];
    if (!instance) return;
    try {
      if (
        instance.readyState === WebSocket.OPEN ||
        instance.readyState === WebSocket.CONNECTING
      ) {
        instance.close(1000, reason);
      }
    } catch (err) {
      console.error("Error closing WebSocket:", err);
    } finally {
      delete this.connectionInstances[sessionId];
    }
  }

  // Send a message to the ws server
  sendMessageFromInstance(sessionId, message, dealershipId) {
    const instance = this.connectionInstances[sessionId];
    try {
      if (instance && instance?.readyState === WebSocket.OPEN) {
        const messageJson = JSON.stringify(message);
        instance.send(messageJson);
      }
    } catch (error) {
      console.error("Error in Connecting to the Websocket Instance:", error);
      newRelicErrorLog(error, {
        dealershipId,
        recordingSessionId: sessionId || "blank:recordingSessionId",
        originated: "AudioStreamingWS Class",
      });
    }
  }
}

export const audioStreamingClientWS = new AudioStreamingWS();
